/* KALIMATI custom sections — scroll reveals + hero parallax. Idempotent. */
(function () {
  if (window.__kalimatiInit) return;
  window.__kalimatiInit = true;

  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // scroll reveal (Story/Founder photos + text)
    var els = document.querySelectorAll('.kal-reveal, .kal-media');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var sibs = Array.prototype.slice.call(e.target.parentElement.querySelectorAll('.kal-reveal, .kal-media'));
            e.target.style.transitionDelay = Math.min(sibs.indexOf(e.target) * 90, 360) + 'ms';
            e.target.classList.add('kal-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('kal-in'); });
    }

    // hero parallax (desktop only) — drift the calligraphy mark vertically
    var heroAr = document.querySelector('.kal-hero-ar');
    var ticking = false;
    function frame() {
      if (heroAr && !reduce && window.innerWidth > 760) {
        var y = window.scrollY;
        var top = heroAr.getBoundingClientRect().top + y;
        if (y < window.innerHeight + top) heroAr.style.transform = 'translateY(calc(-50% + ' + (y * 0.08) + 'px))';
      }
      ticking = false;
    }
    function onScroll() { if (!ticking) { requestAnimationFrame(frame); ticking = true; } }
    window.addEventListener('scroll', onScroll, { passive: true });
    frame();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
